import BmPrivacy from './BmPrivacy'
import { ToolsClass } from '../classes/tools.class'
import MESSAGES from '../messages'
import { getTranslationFromMessages } from '../functions/translation-functions'

let i18nData
const getLocale = () => {
  return i18nData.locale
}
const setLocale = (locale) => {
  i18nData.locale = locale
}
const setFallbackLocale = (locale) => {
  i18nData.fallback = locale
}
const getLocales = () => {
  return Object.keys(i18nData.translations)
}
const addLocale = (locale, translations) => {
  i18nData.translations[locale] = Object.assign({}, i18nData.translations[locale], translations)
  if (!i18nData.locale) {
    i18nData.locale = locale
    i18nData.fallback = locale
  }
}
const replaceLocale = (locale, translations) => {
  i18nData.translations[locale] = translations
}
const removeLocale = (locale) => {
  delete i18nData.translations[locale]
}
const checkLocaleExists = (locale) => {
  return i18nData.translations.hasOwnProperty(locale)
}

const translateInLanguage = (locale, value) => {
  if (typeof locale !== 'string' || typeof value !== 'string') {
    return ''
  }
  let translation = getTranslationFromMessages(value, locale, i18nData.translations)
  if (!translation) {
    translation = getTranslationFromMessages(value, i18nData.fallback, i18nData.translations)
  }
  return translation || value
}

const translate = (value) => {
  return translateInLanguage(i18nData.locale, value)
}

const dateFilter = (value) => new Date(value).toLocaleDateString() + ' ' + new Date(value).toLocaleTimeString()

const install = function (Vue, opts = {}) {
  Vue.component('BmPrivacy', BmPrivacy)
  Vue.filter('date', dateFilter)

  if (!Vue.prototype.$i18n) {
    i18nData = new Vue({
      data: {
        locale: opts.locale || null,
        fallback: opts.fallback || null,
        translations: {}
      }
    })
    Vue.prototype.$i18n = {
      locale: getLocale,
      locales: getLocales,
      set: setLocale,
      add: addLocale,
      replace: replaceLocale,
      remove: removeLocale,
      fallback: setFallbackLocale,
      localeExists: checkLocaleExists,
      translate: translate,
      translateIn: translateInLanguage
    }
    Vue.prototype.$t = translate
    Vue.prototype.$tlang = translateInLanguage
    Vue.filter('translate', translate)
    Vue.filter('translateIn', translateInLanguage)
  }

  ToolsClass.each(MESSAGES, (messages, language) => {
    Vue.prototype.$i18n.add(language, { bmPrivacy: messages })
  })

  Vue.prototype.$bmPrivacyConfig = opts
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install
}
